// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { AuthBaseEntity } from '../auth-base-entity';
import { AspNetUserRole } from './asp-net-user-role';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class AspNetRole extends AuthBaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  id!: string;
  concurrencyStamp?: string;
  description?: string;
  name!: string;
  normalizedName?: string;
  aspNetUserRoles!: AspNetUserRole[];
}

